document.addEventListener('DOMContentLoaded', function () {
  const parkIndexAboutSlider = document.querySelector('.parkIndexAbout__slider');

  if (parkIndexAboutSlider) {
    // window.splide.Extensions から AutoScroll を取り出す
    const AutoScroll = window.splide.Extensions.AutoScroll;

    new Splide(parkIndexAboutSlider, {
      type: 'loop',
      perPage: 5,
      arrows: false,
      pagination: false,
      autoScroll: {
        speed: 0.75,
        pauseOnHover: false,
      },
      breakpoints: {
        1920: {
          perPage: 4,
        },
        1200: {
          perPage: 3,
        },
        840: {
          perPage: 2,
        },
      },
    }).mount({AutoScroll}); // これで認識されます！
  }
});
